import React from 'react'
import "./HeroSection.css";

const HeroSection = () => {
    return (
        <>
            <div className='heroSection'>
                <img className='heroImg' src='https://rashki.com/cdn/shop/files/2_104_2200x.png?v=1729143794' />
                <button className='heroBtn'>SHOP NOW</button>
            </div>
        </>
    )
}

export default HeroSection